import AWS from 'aws-sdk';
import { trimStart } from 'lodash';
import { awsConfig, athenaConfig } from '@/config';

AWS.config.update(awsConfig);

const { region, WorkGroup, Database } = athenaConfig;

const sleep = (wait = 1) => new Promise((r) => setTimeout(r, wait * 1000));

const _submitQueryToAthena = async (QueryString, { Athena } = {}) => {
  Athena = Athena || new AWS.Athena({ region });
  const RETRY_WAIT = 5; // time to wait before retrying a query

  try {
    const queryParams = {
      QueryString,
      WorkGroup,
      QueryExecutionContext: {
        Database
      }
    };
    const { QueryExecutionId } = await Athena.startQueryExecution(queryParams).promise();
    return QueryExecutionId;
  } catch (error) {
    if (['TooManyRequestsException', 'ThrottlingException'].includes(error.code)) {
      await sleep(RETRY_WAIT);
      return await _submitQueryToAthena(QueryString, { Athena });
    } else {
      throw error;
    }
  }
};
export { _submitQueryToAthena as submitQueryToAthena };

const readFromS3 = ({ Bucket, Key }) => {
  const S3 = new AWS.S3();
  return S3.getObject({ Bucket, Key }).promise();
};

const _waitForExecutionCompletion = async (QueryExecutionId, { Athena } = {}) => {
  const RETRY_WAIT = 2; // time to wait before retrying a query
  Athena = Athena || new AWS.Athena({ region });
  const {
    QueryExecution: {
      Query,
      ResultConfiguration: {
        OutputLocation
      },
      Status: {
        StateChangeReason,
        State
      }
    }
  } = await Athena.getQueryExecution({ QueryExecutionId }).promise();
  if (State === 'SUCCEEDED') {
    const [Bucket, Key] = trimStart(OutputLocation, 's3://').split('/');
    return readFromS3({ Bucket, Key });
  } else if (State === 'FAILED') {
    if (StateChangeReason === 'Query exhausted resources at this scale factor') {
      // query failed because life happened
      // https://big-data-demystified.ninja/2019/02/12/aws-athena-error-query-exhausted-resources-at-this-scale-factor/
      QueryExecutionId = await _submitQueryToAthena(Query, { Athena });
      await sleep(RETRY_WAIT);
      return await _waitForExecutionCompletion(QueryExecutionId, { Athena });
    } else {
      throw new Error(StateChangeReason);
    }
  } else {
    await sleep(RETRY_WAIT);
    return await _waitForExecutionCompletion(QueryExecutionId, { Athena });
  }
};
export { _waitForExecutionCompletion as waitForExecutionCompletion };
